/*jshint esversion: 8 */
import React, { Component } from "react";
// import clsx from  'clsx';

import PropTypes from "prop-types";
import { observer } from "mobx-react";

import { withStyles } from "@material-ui/core/styles";
// import { makeStyles } from '@material-ui/core/styles';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

import { toJS } from "mobx";

import store from "../../../components/stores/Store";
import LocalStore from "./LocalStore";
import { getIfFuncAuthorized } from "../../../utils/CheckSomething";

const styles = {
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    // marginBottom: theme.spacing(2),
  },
  tableContainer: {
    // maxHeight: "450px", // todo
    maxWidth: "100%", // todo
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  TableCell: {
    paddingLeft: "4px",
    paddingRight: "4px",
  },
};

class TableInner extends Component {
  constructor(props) {
    super(props);
    store.setOrderByOfTableConfig("createdate");
    store.setOrderOfTableConfig("desc");
    this.state = {
      data: {},

      tableContainerHeight: '500px',
      deleteConfirmDialogOpen: false,
      toDeleteId: '',
    };

    // 通用
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.sortHandler = this.sortHandler.bind(this);
    this.handleSelectAllClick = this.handleSelectAllClick.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.handleCheckClick = this.handleCheckClick.bind(this);

    // 定制 
    this.calcSize = this.calcSize.bind(this);
    this.closeConfirmDialog = this.closeConfirmDialog.bind(this);
    this.deleteLine = this.deleteLine.bind(this);

    this.openUpdateDialog = this.openUpdateDialog.bind(this);
    this.openDeleteDialog = this.openDeleteDialog.bind(this);

  }

  async componentDidMount() {
    this.calcSize();
  }

  componentWillUnmount() { }

  // 通用
  isSelected(id) {
    return store.linesSelected.indexOf(id) !== -1;
  }

  calcSize() {
    // const innerWidth  = window.innerWidth;
    const innerHeight = window.innerHeight;
    // console.log(`----- innerHeight: `, innerHeight);
    this.setState({
      tableContainerHeight: `${innerHeight - 250}px`,
    });
  }

  // 通用
  handleSelectAllClick() {
    const tableLength = store.table.length;
    const selectedLength = store.linesSelected.length;
    console.log(`----- handleSelectAllClick-store.table.length: `, store.table.length);
    console.log(`----- handleSelectAllClick-store.linesSelected.length: `, store.linesSelected.length);
    if (tableLength > selectedLength) {
      // => 全选
      const newSelecteds = store.table.map((n) => n.id);
      store.setLinesSelected(newSelecteds);
    } else if (tableLength === selectedLength) {
      // 全选 => 全不选
      store.setLinesSelected([]);
    } else {
      // 有bug全部清除
      store.setLinesSelected([]);
    }
  }

  // 通用
  handleChangePage(event, newPage) {
    //  console.log(`----- handleChangePage-newPage: `, newPage);
    // this.setState({page: newPage});
    store.setCurrentPageOfTableConfig(newPage);
    store.search();
  }

  // 通用
  handleChangeRowsPerPage(event) {
    store.setRowsPerPageOfTableConfig(parseInt(event.target.value, 10));
    store.setCurrentPageOfTableConfig(0);
    store.search();
  }

  sortHandler(event, header) {
    if (!header.canSort) return;
    const orderBy = header.sid;
    const order = (orderBy === store.tableConfig.orderBy && store.tableConfig.order === 'asc') ? 'desc' : 'asc';
    store.setOrderOfTableConfig(order);
    store.setOrderByOfTableConfig(orderBy);
    store.setCurrentPageOfTableConfig(0);
    store.search();
  }

  // 通用
  handleCheckClick(event, id) {
    console.log(`----- handleCheckClick-id: `, id);
    const selectedIndex = store.linesSelected.indexOf(id);
    let newSelected = [];
    console.log(`----- handleCheckClick-selectedIndex: `, selectedIndex);

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(store.linesSelected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(store.linesSelected.slice(1));
    } else if (selectedIndex === store.linesSelected.length - 1) {
      newSelected = newSelected.concat(store.linesSelected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        store.linesSelected.slice(0, selectedIndex),
        store.linesSelected.slice(selectedIndex + 1)
      );
    }
    console.log(`----- handleCheckClick-newSelected: `, newSelected);

    store.setLinesSelected(newSelected);
  }

  closeConfirmDialog() {
    this.setState({
      toDeleteId: '',
      deleteConfirmDialogOpen: false,
    });
  }

  openDeleteDialog(id) {
    this.setState({
      toDeleteId: id,
      deleteConfirmDialogOpen: true,
    });
  }

  openUpdateDialog(idata) {
    const data = toJS(idata);
    console.log(`----- openUpdateDialog.data: `, data);
    LocalStore.switchUpdateDialog();
    this.setState({ data: data });
    LocalStore.iniUpdateRecordInfo(data);
  }

  async deleteLine() {
    const id = this.state.toDeleteId;
    this.closeConfirmDialog();
    const rst = await this.props.functions.deleteRecord([id]);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "系统错误");
      return true;
    } else if (rst.code === "success") {
      store.openMessageDialogOpen(rst.msg || "删除成功");
      store.search();
      return true;
    }
  }

  render() {
    const { classes } = this.props;
    const emptyRows = Math.max(0, store.tableConfig.rowsPerPage - store.table.length);

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <TableContainer style={{ maxHeight: this.state.tableContainerHeight }}>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"small"}
              aria-label="enhanced table"
              id="table"
            >
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={
                        store.linesSelected.length > 0 &&
                        store.linesSelected.length < store.table.length
                      }
                      checked={
                        store.table.length > 0 &&
                        store.linesSelected.length === store.table.length
                      }
                      onChange={this.handleSelectAllClick}
                      inputProps={{ "aria-label": "select all desserts" }}
                    />
                  </TableCell>
                  {
                    LocalStore.tableFields.map((headCell) => {
                      const tableCellAlign = headCell.tableCellAlign || 'left';
                      if (!headCell.display) return null;
                      const sid = headCell.sid;

                      // console.log(`----- headCell: `, headCell);
                      return (
                        <TableCell
                          key={sid}
                          align={tableCellAlign}
                          padding="normal"
                          sortDirection={
                            store.tableConfig.orderBy === headCell.sid
                              ? store.tableConfig.order
                              : false
                          }
                          className={classes.TableCell}
                        >
                          {headCell.canSort && (
                            <TableSortLabel
                              key={headCell.id}
                              active={store.tableConfig.orderBy === headCell.id}
                              direction={
                                store.tableConfig.orderBy === headCell.id
                                  ? store.tableConfig.order
                                  : "asc"
                              }
                              onClick={(event) =>
                                this.sortHandler(event, headCell)
                              }
                            >
                              {headCell.label}
                              {store.tableConfig.orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                  {store.tableConfig.order === "desc"
                                    ? "sorted descending"
                                    : "sorted ascending"}
                                </span>
                              ) : null}
                            </TableSortLabel>
                          )}

                          {!headCell.canSort && (
                            <TableSortLabel hideSortIcon>
                              {headCell.label}
                            </TableSortLabel>
                          )}
                        </TableCell>);
                    })
                  }
                  <TableCell
                    key='TableCell-action'
                    align='center'
                    padding="normal"
                    className={classes.TableCell}
                  >
                    <TableSortLabel hideSortIcon>操作</TableSortLabel>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody key="TableBody-body">
                {store.table.map((row, index) => {
                  const isItemSelected = this.isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow hover tabIndex={-1} key={`TableRow-${labelId}`}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          key={row.id}
                          checked={isItemSelected}
                          inputProps={{ "aria-labelledby": labelId }}
                          onClick={(event) =>
                            this.handleCheckClick(event, row.id)
                          }
                          className={classes.TableCell}
                        />
                      </TableCell>
                      {
                        Object.keys(row).map((key) => {
                          const sid = key;
                          let tableFieldConfig = {};
                          for (let i = 0; i < LocalStore.tableFields.length; i++) {
                            const element = LocalStore.tableFields[i];
                            if (element.sid === sid) {
                              tableFieldConfig = element;
                              break;
                            } else continue;
                          }

                          if (Object.keys(tableFieldConfig).length === 0) return null;
                          if (!tableFieldConfig.display) return null;

                          const value = row[sid];
                          const align = tableFieldConfig.tableCellAlign || 'left';

                          return (
                            <TableCell key={`${row.id}-${sid}`} align={align} className={classes.TableCell}>
                              {value}
                            </TableCell>
                          );
                        })
                      }
                      <TableCell
                        align="center"
                        style={{ width: "130px" }}
                        className={classes.TableCell}
                      >
                        <ButtonGroup
                          variant="contained"
                          aria-label="contained primary button group"
                        >
                          {(getIfFuncAuthorized('安居房管理-安置房住户明细表-修改')) && (
                            <Button
                              color="primary"
                              onClick={(e) => this.openUpdateDialog(row)}
                            >
                              修改
                            </Button>
                          )}
                          {(getIfFuncAuthorized('安居房管理-安置房住户明细表-删除')) && (
                            <Button
                              color="secondary"
                              onClick={() => this.openDeleteDialog(row.id)}
                            >
                              删除
                            </Button>
                          )}
                        </ButtonGroup>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 74 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 20, 40]}
            component="div"
            count={store.tableCount}
            rowsPerPage={store.tableConfig.rowsPerPage}
            page={store.tableConfig.currentPage}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            labelRowsPerPage='每页行数'
            SelectProps={{
              inputProps: {
                'aria-label': '每页行数: ',
              },
              native: true,
            }}
          />
        </Paper>

        <Dialog
          open={this.state.deleteConfirmDialogOpen}
          onClose={this.closeConfirmDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ width: '400px' }}>
            {"确认删除？"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => this.deleteLine()} color="secondary">
              确认删除
            </Button>
            <Button onClick={this.closeConfirmDialog} color="primary" autoFocus>
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const TableObserver = observer(TableInner);

TableObserver.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TableObserver);
